<template>
  <div class="sales-orders" v-loading="loading">
    <bean-filter
      v-model="filter"
      size="mini"
      :columns="shareFilterColumns"
      @filter="handleFilter"
      @reset="handleReset"
    />

    <div class="table-content">
      <bean-table
        :columns="tableColumns"
        :data="tableData"
        :stripe="false"
      />
    </div>
    <SalesOrderSummary :summary="summary" style="margin-bottom: 10px;" />
    <bean-pagination
      v-if="pagination.total > 0"
      v-bind="pagination"
      @submit="handlePaginationSubmit"
    />
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { orderTableColumns, JushuitanOrders } from '@/utils/order';
import SalesOrderSummary from '@/components/sales-order-summary.vue';
import _ from 'lodash';
import shareFilterColumns from './share-filter-columns';

@Component({
  components: {
    SalesOrderSummary,
  }
})
export default class Orders extends Vue {
  @Prop({ type: [String, Number], required: true }) commissionSourceId;
  @Prop({ type: Object, default: () => ({}) }) initParams;

  filter = {};

  loading = false;
  tableColumns = orderTableColumns.map(item => {
    if (item.prop === 'jushuitan_orders') {
      return {
        ...item,
        minWidth: 120 * 4 + 30,
        renderCell: (h, { props: { value } }) => {
          return <JushuitanOrders value={value} showFields={['o_id', 'real_freight', 'cost', 'profit']} />;
        }
      }
    }
    return item;
  });
  pagination = {};

  defaultParams = {
    page: 1,
    per_page: 25
  };

  tableData = [];
  summary = {};
  shareFilterColumns = shareFilterColumns;

  async fetchList(params = {}) {
    this.loading = true;
    try {
      const res = await this.$request.get(`/reports/commission_sources/${this.commissionSourceId}/sales_orders`, { params: { ...this.defaultParams, ...params, ...this.filter } });
      this.tableData = res.data;
      this.pagination = res.pagination;
    } finally {
      this.loading = false;
    }
  }

  async fetchSummary() {
    this.summary = await this.$request.get(`/reports/commission_sources/${this.commissionSourceId}/sales_orders/summary`, { params: { ...this.filter } });
  }

  fetchData() {
    this.fetchList();
    this.fetchSummary();
  }

  created() {
    this.filter = _.cloneDeep(this.initParams);
  }

  mounted() {
    this.fetchData();
  }

  handlePaginationSubmit({ page, size }) {
    this.fetchList({ page, per_page: size });
  }

  handleFilter() {
    this.fetchData();
  }

  handleReset() {
    this.filter = {};
    this.fetchData();
  }
}
</script>

<style lang="scss" scoped>
.sales-orders {
  height: 100%;
  display: flex;
  flex-direction: column;

  .table-content {
    flex: 1;
    overflow: hidden;
  }
}
</style>
